<section class="service-step">
  <app-shipment-stepper [activeStepIndex]="activeStepIndex" />

  <div class="service-step__content">
    <div class="service-step__layout">
      <div class="service-step__main">
        <app-delivery-service-selection
          (selectionChange)="onDeliverySelectionChange($event)"
          (breakdownChange)="onEstimatedBreakdownChange($event)"
          (skeletonChange)="onDeliverySkeletonChange($event)"
          (offeringsUnresolvedChange)="onDeliveryOfferingsUnresolvedChange($event)"
        />

        @if (!deliveryRegionBusy()) {
          <app-signature-protection-section
            [form]="signatureProtectionForm"
            [availableRequirements]="signatureAvailableRequirements()"
            [includedRequirements]="signatureIncludedRequirements()"
            [destinationResidential]="signatureDestinationResidential()"
          />

          <app-additional-coverage-section
            [form]="additionalCoverageForm"
            [showValidationErrors]="showValidationErrors()"
            (declaredValueCommitted)="onDeclaredValueCommitted()"
          />

          <app-pickup-drop-off
            [state]="pickupDropOffState()"
            [shipFrom]="shipFrom()"
            [pickupSchedulingEnabled]="pickupSchedulingEnabled()"
            [availabilityLoading]="availabilityLoading()"
            [availabilityError]="availabilityError()"
            [availabilityNotice]="availabilityNotice()"
            [pickupNotSupportedAtAddress]="pickupNotSupportedAtAddress()"
            [windowNotice]="windowNotice()"
            [locationsLoading]="locationsLoading()"
            [locationsError]="locationsError()"
            [locatorLoading]="locatorLoading()"
            [locatorError]="locatorError()"
            [showValidationErrors]="showValidationErrors()"
            (methodChange)="onMethodChange($event)"
            (dateChange)="onDateChange($event)"
            (windowChange)="onWindowChange($event)"
            (locationCodeChange)="onLocationCodeChange($event)"
            (courierInstructionsChange)="onCourierInstructionsChange($event)"
          />

          @if (showValidationErrors() && !isPickupValid()) {
            <p class="service-step__validation-summary" role="alert">
              {{ 'createShipment.validation.errorSummaryTitle' | translate }}
            </p>
          }
        }
      </div>

      <app-estimated-costs-panel
        [breakdown]="estimatedBreakdown()"
        [showSkeleton]="showDeliverySkeleton()"
        [pending]="deliveryOfferingsUnresolved()"
      />
    </div>

    @if (showDeliverySkeleton()) {
      <div class="service-step__actions service-step__actions--skeleton" aria-hidden="true">
        <app-skeleton-block width="84" height="46" tone="secondary" />
        <app-skeleton-block width="188" height="46" />
      </div>
    } @else if (!deliveryOfferingsUnresolved()) {
      <div
        class="service-step__actions"
        [attr.aria-busy]="saveAndContinueInProgress() ? 'true' : null"
      >
        @if (saveAndContinueInProgress()) {
          <output class="visually-hidden" data-testid="service-save-processing-status">
            {{ 'createShipment.actions.saveAndContinueSaving' | translate }}
          </output>
        }

        <puro-button
          type="button"
          variant="secondary"
          size="large"
          data-testid="service-back"
          [disabled]="saveAndContinueInProgress()"
          (buttonClick)="onBack()"
        >
          {{ 'createShipment.serviceStep.actions.back' | translate }}
        </puro-button>

        <puro-button
          type="button"
          variant="primary"
          size="large"
          data-testid="service-save-continue"
          [loading]="saveAndContinueInProgress()"
          [disabled]="saveAndContinueInProgress()"
          (buttonClick)="onSaveAttempted()"
        >
          {{ 'createShipment.serviceStep.actions.saveAndContinue' | translate }}
        </puro-button>
      </div>
    }
  </div>
</section>
